import styled from "styled-components"
import { theme } from "../../../theme"
import { Button } from "../../atoms/button"

export const PopperSaveButton = styled(Button)`
  width: 100%;
  margin-top: ${theme.spacing.lx};
  background-color: ${(p) => p.theme.primaryColor};
  text-transform: uppercase;
  color: ${(p) => p.theme.buttonTextColor};

  &:hover {
    background-color: ${(p) => p.theme.primaryColor};
  }
`
